import { useState, useRef, useEffect } from 'react';
import useLogout from '../../../hooks/useLogout';
import { useNavigate } from 'react-router-dom';
import PmsUrlConfig from '../../../urlConfig';

export const useUserDropdown = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const handleLogout = useLogout();
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Toggle dropdown
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close dropdown
  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  // Handle profile management
  const handleProfileManagement = () => {
    closeDropdown();
    navigate(PmsUrlConfig.SETTINGS);
  };

  // Handle logout
  const handleLogoutClick = () => {
    closeDropdown();
    handleLogout();
  };

  return {
    isDropdownOpen,
    dropdownRef,
    toggleDropdown,
    closeDropdown,
    handleProfileManagement,
    handleLogoutClick
  };
};
